import React from "react";
import { Entry } from "contentful";
import { BrandInvestmentDownloads } from "@tiicker/util/lib/contentful/types";
import styles from "./Downloads.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/sharp-light-svg-icons";

type Props = {
  downloads: Entry<BrandInvestmentDownloads>[];
};

const Downloads: React.FC<Props> = ({ downloads }: Props) => {
  if (!downloads) return null;

  const handleDownload = (url: string, fileName: string) => {
    // Ensure URL starts with https:
    const fullUrl = url.startsWith("//") ? `https:${url}` : url;

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = fullUrl;
    link.download = fileName; // Set suggested filename
    link.target = "_blank"; // Open in new tab as fallback
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={styles.Downloads}>
      <h2 className={styles.Downloads__title}>Downloads</h2>
      <div className={styles.Downloads__contents}></div>
      {downloads.map((download, index) => {
        const fileUrl = download.fields.downloadFile.fields.file.url;
        const fileName = download.fields.downloadFile.fields.file.fileName;

        return (
          <div className={styles.Downloads__row} key={index}>
            <div className={styles.Downloads__download}>
              <div
                className={styles.Downloads__clickable}
                onClick={() => handleDownload(fileUrl, fileName)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleDownload(fileUrl, fileName);
                }}
              >
                <FontAwesomeIcon
                  icon={faFileArrowDown}
                  className={styles.Downloads__icon}
                  style={{ color: download.fields.iconHex }}
                />
                <h4 className={styles.Downloads__fileName}>
                  {download.fields.downloadFile.fields.title}.pdf
                </h4>
              </div>
            </div>
            <p className={styles.Downloads__description}>
              {download.fields.description}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default Downloads;
